import { atom } from 'recoil'
import { IAccess } from '@griegconnect/krakentools-react-tenants'

export type UserAccessAtomType = IAccess

export const userAccessAtom = atom<UserAccessAtomType | null>({
  key: 'userAccessState',
  default: null,
})
